import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=edab8a64&scoped=true&"
var script = {}
import style0 from "./Services.vue?vue&type=style&index=0&id=edab8a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edab8a64",
  null
  
)

export default component.exports